import { useLocation } from "react-router-dom";
import { ROUTES, WORDPRESS_URL } from "@constants";

export const useNavigation = () => {
    const location = useLocation();

    const isWordPressLink = (route: string) => (WORDPRESS_URL ? route.startsWith(WORDPRESS_URL) : false);

    const isRouteActive = (linkRoute: string) => {
        const currentPathname = location.pathname;

        if (ROUTES.ESHOP_URL && linkRoute.startsWith(ROUTES.ESHOP_URL)) {
            const routeWithoutEshop = linkRoute.replace(ROUTES.ESHOP_URL, "");

            return currentPathname === routeWithoutEshop || currentPathname.startsWith(routeWithoutEshop + "/");
        }

        return currentPathname === linkRoute || currentPathname.startsWith(linkRoute + "/");
    };

    return {
        isWordPressLink,
        isRouteActive,
    };
};
